// Macro donut chart (Swift Charts SectorMark) drawn with react-native-svg.
import React from 'react';
import { Text, View } from 'react-native';
import Svg, { Circle } from 'react-native-svg';
import { CHART_COLORS as COLORS, font, spacing, usePalette } from '../theme';

export default function Donut({ slices, size = 180 }: { slices: { title: string; grams: number }[]; size?: number }) {
  const p = usePalette();
  const total = slices.reduce((s, x) => s + x.grams, 0);
  const stroke = size * 0.18;
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  let offset = 0;
  return (
    <View style={{ alignItems: 'center', gap: spacing.m }}>
      <Svg width={size} height={size} accessibilityLabel={slices.map(s => `${s.title} ${s.grams.toFixed(1)} g`).join(', ')}>
        {slices.map((s, i) => {
          const len = total > 0 ? (s.grams / total) * c : 0;
          const el = (
            <Circle
              key={s.title}
              cx={size / 2}
              cy={size / 2}
              r={r}
              stroke={COLORS[i % COLORS.length]}
              strokeWidth={stroke}
              fill="none"
              strokeDasharray={`${len} ${c - len}`}
              strokeDashoffset={-offset}
              rotation={-90}
              origin={`${size / 2}, ${size / 2}`}
            />
          );
          offset += len;
          return el;
        })}
      </Svg>
      <View style={{ flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'center', gap: spacing.m }}>
        {slices.map((s, i) => (
          <View key={s.title} style={{ flexDirection: 'row', alignItems: 'center', gap: 6 }}>
            <View style={{ width: 10, height: 10, borderRadius: 5, backgroundColor: COLORS[i % COLORS.length] }} />
            <Text style={{ fontSize: font.footnote, color: p.text }}>{s.title} {s.grams.toFixed(1)} g</Text>
          </View>
        ))}
      </View>
    </View>
  );
}
